import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Collapse } from '@material-ui/core';

import Breadcrumb from 'components/commons/Breadcrumb';
import Loading from 'components/commons/Loading';

import './TrackingGuide.scss';

const TrackingGuide = (props) => {
  const { guideNumber, trackingGuide, guide, loading } = props;
  const [openShipping, setOpenShipping] = useState(true);

  return (
    <div data-testid="tracking-guide-page">
      <div className="container">
        <div className="row">
          <div className="col clearfix">
            <Breadcrumb urls={['/seguimiento-de-envio']} names={['Seguimiento de envío']} />
          </div>
        </div>
        {loading ? (
          <Loading />
        ) : (
          !!guide && (
            <div className="row">
              <div className="col">
                <strong>Envío n°{guideNumber}</strong>
                <br />
                {guide.state && (
                  <>
                    <h4>{guide.state}</h4>
                  </>
                )}
                <strong>Fecha de envío:</strong> {guide.date}
                <br />
                <h4>
                  Paso a paso del envío
                  <ExpandMoreIcon
                    style={{ fontSize: '36px', position: 'relative', top: '10px' }}
                    onClick={() => setOpenShipping(!openShipping)}
                    aria-expanded={openShipping}
                    data-testid="expand-shipping"
                  />
                </h4>
                <Collapse in={openShipping}>
                  <div id="example-collapse-text">
                    <ol style={{ marginLeft: '18px' }}>
                      {trackingGuide?.guia?.fechas?.map((fecha) => (
                        <li key={`${fecha.fecha}-${fecha.hora}`}>
                          {fecha.fecha} {fecha.hora} - {fecha.estado}
                        </li>
                      ))}
                    </ol>
                  </div>
                </Collapse>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

TrackingGuide.propTypes = {
  guideNumber: PropTypes.string.isRequired,
  trackingGuide: PropTypes.object.isRequired,
  guide: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default TrackingGuide;
